import Image from 'next/image'
import Link from 'next/link'

import { BASE_URL } from '@/shared/lib/const/env'
import { TBurgerLevel2 } from '@/shared/types/deprecated-types'

import cl from './style.module.scss'

interface PopupBrandsProps {
	items: TBurgerLevel2[]
}

export const PopupBrands = (props: PopupBrandsProps) => {
	const { items } = props

	return (
		<div className={cl.brands}>
			<h4 className={cl.title}>Популярные бренды</h4>
			<ul className={cl.list}>
				{items[0].LINKS.map(item => (
					<li key={item.LINK} className={cl.item}>
						<Link href={item.LINK} className={cl.link} prefetch={false}>
							{item?.IMAGE && <Image src={BASE_URL + item.IMAGE} alt={''} width={100} height={48} className={cl.img} />}
						</Link>
					</li>
				))}
			</ul>
		</div>
	)
}
